import { Injectable, signal } from "@angular/core";
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class BalanceService {
  isPaymentWithBalance = signal(false);

  // Observable para notificar cambios en el estado de pago con balance
  isPaymentWithBalanceChanged = toObservable(this.isPaymentWithBalance);

  constructor() {
    // No necesitamos effect, toObservable maneja la conversión automáticamente
  }
}
